export default "__VITE_ASSET__978ce994__"